import { SourceOutputExampleType, sourceOutputExampleTypeToJSON } from '~/protos/agents'

export const InputOutputExamples = [
  {
    label: 'XML -> JSON',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_XML),
    input: `
<?xml version='1.0' encoding='UTF-8'?>
<order>
  <product>
    <price>5</price>
    <model>MuleSoft Connect 2016</model>
  </product>
  <item_amount>3</item_amount>
  <payment>
    <payment-type>credit-card</payment-type>
    <currency>USD</currency>
    <installments>1</installments>
  </payment>
  <buyer>
    <email>mike@hotmail.com</email>
    <name>John Doe</name>
    <address>Koala Boulevard 314</address>
    <city>San Diego</city>
    <state>CA</state>
    <postCode>1345</postCode>
    <nationality>USA</nationality>
  </buyer>
  <shop>main branch</shop>
  <salesperson>Mathew Chow</salesperson>
</order>
        `.trim(),
    output: `
{
  "address1": "Koala Boulevard 314",
  "city": "San Diego",
  "country": "USA",
  "email": "mike@hotmail.com",
  "first_name": "John",
  "last_name": "Doe",
  "postalCode": "1345",
  "stateOrProvince": "CA"
}
         `.trim()
  },
  {
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON),
    label: 'JSON -> JSON',
    input: `
[
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 1,
    "marks": 9
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 2,
    "marks": 9.5
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 3,
    "marks": 8
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 4,
    "marks": 7
  }
]
        `.trim(),
    output: `
 [
  {
    "SID": 101,
    "SNAME": "Rahul",
    "CGP": 8.375
  }
]
         `.trim()
  },
  {
    label: 'JSON -> XML',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON),
    input: `
{
  "superhero": "Muletron",
  "dataSnacks": ["XML Cookies", "JSON Jellies", "API Apples", "Binary Biscuits"]
}
        `.trim(),
    output: `
<?xml version='1.0' encoding='UTF-8'?>
<superhero>
  <name>Muletron</name>
  <snackSaga>
    <snack>XML Cookies</snack>
  </snackSaga>
  <snackSaga>
    <snack>JSON Jellies</snack>
  </snackSaga>
  <snackSaga>
    <snack>API Apples</snack>
  </snackSaga>
  <snackSaga>
    <snack>Binary Biscuits</snack>
  </snackSaga>
</superhero>
         `.trim()
  },
  {
    label: 'YAML -> JSON',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_YAML),
    input: `
name: starwars collection
year of publication:
    - 1977
    - 1980
    - 1983
movies:
# Only movies from the original trilogy (OT) are listed here.
    ot:
       - Episode IV - A New Hope
       - Episode V - The Empire Strikes Back
       - "Episode VI - Return of the Jedi Knights."
        `.trim(),
    output: `
[
   {
      "year":1977,
      "ot":"Episode IV - A New Hope"
   },
   {
      "year":1980,
      "ot":"Episode V - The Empire Strikes Back"
   },
   {
      "year":1983,
      "ot":"Episode VI - Return of the Jedi Knights."
   }
]
         `.trim()
  }
] as const
